import { render } from "./ToolbarColorPicker.vue?vue&type=template&id=5b0f411d"
import script from "./ToolbarColorPicker.vue?vue&type=script&lang=js"
export * from "./ToolbarColorPicker.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__